export type SuperModelSelectOption = {
  value: string;
  labelKey?: string;
  label?: string;
};

export const MANUFACTURER_OPTIONS: SuperModelSelectOption[] = [
  { value: "1", labelKey: "MANUFACTURERS.DATA.MERCEDES" },
  { value: "2", labelKey: "MANUFACTURERS.DATA.MAN" },
];
